import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine11 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#6E491E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.0672 5.44019V18.6921H7.25137V8.27427C6.80085 8.63088 5.46833 9.32532 4.98024 9.56949L4.28581 9.9261L3.38477 7.89888L4.1919 7.52349C5.73103 6.79175 7.15772 5.90949 7.75824 5.44019H10.0672ZM18.0863 5.44019V18.6921H15.2705V8.27427C14.8202 8.63088 13.4875 9.32532 12.9996 9.56949L12.3052 9.9261L11.4039 7.89888L12.211 7.52349C13.7502 6.79175 15.1766 5.90949 15.7774 5.44019H18.0863Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLine11);
export { ForwardRef as ReactComponent };
